export default function Footer() {
  return (
    <footer data-testid="app-footer" className="w-full py-6 mt-10 border-t border-zinc-900">
      <p className="text-center text-xs text-gray-500">
        © 2026 Bản quyền thuộc về Nguyễn Trịnh Phúc Khang.
      </p>
    </footer>
  );
}
